<template>
  <div class="navcontainer _navcontainer">
    <div class="navicon _navicon">
      <i class="iconfont icon-caidan" @click="opencaidan()"></i>
    </div>
    <div class="prime_icon" @click="routerpush('/')">
      <img src="../../static/home/logo.png" alt="返回首页">
    </div>
    <div id="navID" class="mainnavlist _mainnavlist">
      <div class="navlistclose nav_content">
        <i @click="closecaidan()" class="iconfont icon-guanbi"></i>
      </div>
      <div class="nav_content" @click="routerpush('/series-s')">{{ $t('topWindow.seriesS') }}</div>
      <div class="nav_content" @click="routerpush('/support')">{{ $t('topWindow.support') }}</div>
      <div class="nav_content" @click="routerpush('/contact')">{{ $t('topWindow.contact') }}</div>
      <div v-if="!isMobile" style="margin-left: 30%;width: 20px;position: absolute" @click="changeLanguage('zh')">简</div>
      <div v-else class="nav_content" @click="changeLanguage('zh')">简</div>
      <div v-if="!isMobile" style="margin-left: 34%;width: 20px;position: absolute" @click="changeLanguage('en')">EN</div>
      <div v-else class="nav_content" @click="changeLanguage('en')">EN</div>
    </div>
    <!-- 搜索图标 -->
<!--    <div @click="routerpush('/')" style="margin-left: 10px">-->
<!--      <i class="iconfont icon-sousuo1"></i>-->
<!--    </div>-->

    <!-- 新增遮罩层 -->
    <div v-if="showOverlay" class="menu-overlay" @click="closecaidan()"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'navtop',
  components: {},
  data() {
    return {
      nalistshowflag: false,
      showOverlay: false, // 新增遮罩层显示状态
      isMobile: window.innerWidth < 800,
    }
  },
  methods: {
    changeLanguage(lan){
      this.$i18n.locale = lan;
      const currentPath = this.$route.fullPath;
      const oldLan = lan === 'en' ? 'zh' : 'en'; // 如果新语言是 en，旧语言就是 zh，反之亦然
      const newPath = currentPath.replace(oldLan, lan)
      if (newPath && newPath !== currentPath) {
        this.$router.replace(newPath);
      }
      window.location.reload();
    },
    routerpush(to) {
      let path = this.$route.path;
      if (path.startsWith('/zh')) {
        this.$router.push('/zh' + to).then(() => {
          window.location.reload();
        });
      }
      if (path.startsWith('/en')) {
        this.$router.push('/en' + to).then(() => {
          window.location.reload();
        });
      }
      const dom = document.getElementById('navID')
      if (dom && dom.classList.contains('navlistshow')) {
        dom.classList.remove('navlistshow')
        this.showOverlay = false
      }
    },
    opencaidan() {
      const dom = document.getElementById('navID')
      if (dom && !dom.classList.contains('navlistshow')) {
        dom.classList.add('navlistshow')
        this.showOverlay = true
      }
    },
    closecaidan() {
      const dom = document.getElementById('navID')
      if (dom && dom.classList.contains('navlistshow')) {
        dom.classList.remove('navlistshow')
        this.showOverlay = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/CSS/iconfonts.css";
// 基础变量，方便统一调整
@base-text-color: rgba(39, 37, 37, 0.91); // 默认文字色
@hover-text-color: #000; //  hover 后文字色
@mobile-bg: rgba(0, 0, 0, 0.95); // 移动端菜单背景
@border-color: rgb(214, 214, 214); // 分割线颜色
@overlay-bg: rgba(0, 0, 0, 0.5); // 遮罩层背景色

// 大于800px
@media only screen and (min-width: 800px) {
  .navcontainer {
    position: fixed;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: rgba(255, 255, 258, 0.9);
    backdrop-filter: blur(12px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    z-index: 100;
    transition: all 0.3s ease;

    .navicon {
      display: none;
      cursor: pointer;
    }

    .mainnavlist {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      color: @base-text-color;

      .navlistclose {
        display: none;
      }

      div {
        text-align: center;
        height: 40px;
        line-height: 40px;
        width: 95px;
        cursor: pointer;
        font-size: 14px;
        transition: color 0.2s ease;
      }

      div:hover {
        color: @hover-text-color;
      }
    }

    .prime_icon {
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
}

// 小于800px
@media only screen and (max-width: 800px) {
  ._navcontainer {
    position: fixed;
    top: 0;
    z-index: 99999; /* 导航栏保持较高层级 */
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    width: 100%;
    background-color: rgba(255, 255, 258, 0.9);
    backdrop-filter: blur(12px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    ._navicon {
      position: absolute;
      right: 15px;
    }

    ._mainnavlist {
      display: none;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 3000; /* 菜单层级高于遮罩层 */
      padding-top: 40px;
      width: 100%; /* 侧边菜单效果 */
      height: 800px;
      color: black;
      background-color: white;
      flex-direction: column;
      transition: transform 0.3s ease;
      transform: translateX(-100%);

      &.navlistshow {
        transform: translateX(0); /* 显示时滑入 */
      }

      div {
        text-align: left;
        height: 40px;
        line-height: 40px;
        width: 100%;
        font-size: 15px;
        transition: color 0.2s ease;
      }

      div:hover {
        color: @hover-text-color;
      }

      .nav_content {
        margin-left: 15px;
      }
    }
  }

  .navlistshow {
    display: flex !important; /* 改为flex确保布局正确 */
  }

  .icon-sousuo1 {
    display: none;
  }

  // 遮罩层样式
  .menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2500; /* 遮罩层级在导航栏和菜单之间 */
    background-color: @overlay-bg;
    transition: opacity 0.3s ease;
  }
}

// 图标+文字通用优化
.prime_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 48px;
  min-height: 30px;

  @media (max-width: 768px) {
    position: absolute;
  }

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;

    @media (max-width: 768px) {
      width: 30px;
      height: 30px;
    }
  }
}

.prime_icon:hover {
  //background-color: rgba(0, 0, 0, 0.05);
}

.prime_icon:active {
  transform: scale(0.95);
}
</style>
